import { HTMLAttributes } from 'react';
import {
  MarketList,
  MarketContentCard,
  MarketActivityIndicator,
} from '@market/react';
import OptionRow, {
  StyledText,
} from 'typescript/components/option_rows/option_row';
import styles from 'typescript/components/option_rows/option_rows.module.scss';

export const OPTIONS_LIST_TEST_ID = 'options-list-test-id';
export const LOADER_TEST_ID = 'loader-test-id';

export interface Options {
  id: string;
  title: string;
  subtext: (string | StyledText)[];
  sideLabel: string;
  value: string;
  disabled?: boolean;
  selected?: boolean;
}

export interface OptionRowsProps extends HTMLAttributes<HTMLElement> {
  dataTestId?: string;
  disabled?: boolean;
  header?: string;
  options?: Options[];
  onOptionSelect?: ({ optionId }: { optionId: string }) => void;
}

const OptionRows = ({
  className,
  dataTestId,
  disabled = false,
  header,
  options,
  onOptionSelect,
}: OptionRowsProps) => {
  return (
    <div className={className} data-testid={dataTestId}>
      {header && <h3>{header}</h3>}
      {options ? (
        <MarketList
          data-testid={OPTIONS_LIST_TEST_ID}
          onMarketListSelectionsDidChange={(e) => {
            onOptionSelect({
              optionId: e.detail.newSelectionValue,
            });
          }}
        >
          {options.map((option) => (
            <OptionRow
              dataTestId={`option-${option.id}-test-id`}
              key={option.id}
              optionKey={option.id}
              title={option.title}
              subtext={option.subtext}
              sideLabel={option.sideLabel}
              value={option.id}
              disabled={option.disabled || disabled}
              selected={option.selected}
            />
          ))}
        </MarketList>
      ) : (
        <MarketContentCard
          data-testid={LOADER_TEST_ID}
          className={`${styles.loadingCard} ${className}`}
        >
          <MarketActivityIndicator />
        </MarketContentCard>
      )}
    </div>
  );
};

export default OptionRows;
